// Cart functionality
import { getCart, addToCart, removeFromCart, updateCartItemQuantity } from '../core/store.js';
import { getDomElements } from '../utils/dom.js';

let domRefs;

export function initCart() {
    domRefs = getDomElements();

    // Add cart badge to cart button
    const cartBadge = document.createElement('span');
    cartBadge.className = 'cart__badge';
    cartBadge.textContent = '0';

    domRefs.cartButton.appendChild(cartBadge);

    attachCartEventListeners();
    attachCartItemEventListeners();
    updateCartContents();
    updateCartBadge();
}

function attachCartEventListeners() {
    // Toggle cart visibility
    domRefs.cartButton.addEventListener("click", () => {
        toggleCartVisibility();
        updateCartContents();
    });

    // Close cart when clicking 'X' button
    domRefs.closeCartButton.addEventListener("click", hideCart);

    // Close cart when clicking outside the cart section
    document.addEventListener("click", handleOutsideCartClick);

    // Prevent propagation of clicks inside the cart
    domRefs.cartSection.addEventListener("click", (event) => {
        event.stopPropagation();
    });

    // Checkout button functionality
    document.getElementById("checkout-btn").addEventListener("click", handleCheckout);
}

function attachCartItemEventListeners() {
    // Attach listeners to the container
    domRefs.cartContents.addEventListener('click', (event) => {
        const target = event.target;

        // Find the closest cart item
        const cartItem = target.closest('.cart__item');
        if (!cartItem) return;

        // Get the item index from a data attribute
        const index = parseInt(cartItem.dataset.itemIndex, 10);

        // Handle decrease button
        if (target.classList.contains('cart__quantity-decrease')) {
            const quantityElement = cartItem.querySelector('.cart__quantity-value');
            const currentQuantity = parseInt(quantityElement.textContent, 10);
            updateItemQuantity(index, currentQuantity - 1);
        }

        // Handle increase button
        else if (target.classList.contains('cart__quantity-increase')) {
            const quantityElement = cartItem.querySelector('.cart__quantity-value');
            const currentQuantity = parseInt(quantityElement.textContent, 10);
            updateItemQuantity(index, currentQuantity + 1);
        }

        // Handle remove button
        else if (target.classList.contains('cart__remove-btn')) {
            removeFromCart(index);
            updateCartContents();
            updateCartBadge();
        }
    });
}

function updateItemQuantity(index, newQuantity) {
    if (newQuantity <= 0) {
        removeFromCart(index);
    } else {
        updateCartItemQuantity(index, newQuantity);
    }
    updateCartContents();
    updateCartBadge();
}

export function addItemToCart(product, size) {
    const selectedVariant = product.variants.find(v => v.title === size);

    if (!selectedVariant) {
        console.error(`Could not find variant with size ${size}`);
        return;
    }

    const newItem = {
        id: product.id,
        title: product.title,
        size: size,
        price: selectedVariant.price || product.price,
        variant_id: selectedVariant.id
    };

    addToCart(newItem);
    // Cart icon animation
    const cartButton = domRefs.cartButton;
    cartButton.classList.add('cart__btn-bump');
    setTimeout(() => {
        cartButton.classList.remove('cart__btn-bump');
    }, 500);

    updateCartContents();
    updateCartBadge();
}

export function updateCartContents() {
    const cart = getCart();
    const { cartContents } = domRefs;
    cartContents.innerHTML = "";

    if (cart.length === 0) {
        cartContents.innerHTML = "<p>Your cart is currently empty.</p>";
        return;
    }

    // TODO handle currency
    cart.forEach((item, index) => {
        const cartItem = document.createElement("div");
        cartItem.className = "cart__item";
        cartItem.dataset.itemIndex = index;
        cartItem.innerHTML = `
            <div class="cart__item-info">
                <div class="cart__item-title">${item.title}</div>
                <div class="cart__item-variant">Size: ${item.size}</div>
            </div>
            <div class="cart__item-price">£${(item.price * item.quantity).toFixed(2)}</div>
            <div class="cart__item-controls">
                <div class="cart__quantity-control">
                    <button class="cart__quantity-btn cart__quantity-decrease" aria-label="Decrease quantity">-</button>
                    <span class="cart__quantity-value">${item.quantity}</span>
                    <button class="cart__quantity-btn cart__quantity-increase" aria-label="Increase quantity">+</button>
                </div>
                <button class="cart__remove-btn">Remove</button>
            </div>
        `;

        cartContents.appendChild(cartItem);
    });
}

function toggleCartVisibility() {
    domRefs.cartSection.classList.toggle("visible");
}

function hideCart() {
    domRefs.cartSection.classList.remove("visible");
}

function handleOutsideCartClick(event) {
    const isClickInsideCart = domRefs.cartSection.contains(event.target);
    const isClickCartButton = domRefs.cartButton.contains(event.target);

    if (!isClickInsideCart && !isClickCartButton) {
        hideCart();
    }
}

function updateCartBadge() {
    const cart = getCart();
    const badge = document.querySelector('.cart__badge');

    if (!badge) return;

    const itemCount = cart.reduce((total, item) => total + item.quantity, 0);
    badge.textContent = itemCount;

    if (itemCount > 0) {
        badge.classList.add('visible');
    } else {
        badge.classList.remove('visible');
    }
}

function handleCheckout() {
    const cart = getCart();
    if (cart.length === 0) {
        alert("Your cart is empty. Add items before checking out.");
        return;
    }

    // Build the checkout URL
    const shopifyDomain = import.meta.env.VITE_SHOPIFY_DOMAIN;
    let checkoutUrl = `https://${shopifyDomain}/cart/`;
    checkoutUrl += cart.map(item =>
        `${item.variant_id}:${item.quantity}`
    ).join(',');

    window.location.href = checkoutUrl;
}